import { render } from "./ScalesFilter.vue?vue&type=template&id=07065a7c&ts=true"
import script from "./ScalesFilter.vue?vue&type=script&lang=ts"
export * from "./ScalesFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__